import { render, staticRenderFns } from "./ProjectActionApplyProfileCheck.vue?vue&type=template&id=3673d4e8"
import script from "./ProjectActionApplyProfileCheck.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectActionApplyProfileCheck.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports